<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push({ path: '/' })">首页</span>
        <span>></span>
        <span>会员权益</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="member">
            <h3>会员权益</h3>
            <div class="img">
              <img :src="memberImg" alt />
            </div>
            <el-button @click="memberBtn">开通会员</el-button>
          </div>
          <div class="member">
            <h3>权益对比详情表</h3>
            <div class="img">
              <img :src="detailImg" alt />
            </div>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
    <div class="dialog">
      <!-- 会员订阅 -->
      <el-dialog :visible.sync="subscribeDialog" width="800px" :close-on-click-modal="false" class="singleDialog">
        <div class="singleList">
          <div class="header">
            <div class="message">
              <div class="img">
                <img :src="info.avatar" alt />
              </div>
              <div>
                <p>{{ info.nickname }}</p>
                <p>
                  账号
                  <span>{{ info.login_name }}</span> ,
                  <!-- {{ info }} -->
                  <template v-if="
                    info.has_read_ability &&
                    info.read_pro_expired_at != null &&
                    info.read_ability_expired_at != null
                  ">{{ info.read_pro_expired_at }},{{
                      info.read_ability_expired_at
                    }}</template>
                  <template v-else-if="
                    info.has_read_ability && info.read_pro_expired_at != null
                  ">{{ info.read_pro_expired_at }}</template>
                  <template v-else-if="
                    info.has_read_ability &&
                    info.read_ability_expired_at != null
                  ">{{ info.read_ability_expired_at }}</template>
                  <template v-if="!info.has_read_ability">您还不是VIP会员</template>
                </p>
              </div>
            </div>
            <div class="close">
              <img src="@/assets/img/icon_close.png" @click="subscribeClose" alt />
            </div>
          </div>
          <div class="dialog-body">
            <h3>
              <img src="@/assets/img/icon_member.png" alt />
              <span>会员套餐</span>
            </h3>
            <div class="body-message">
              <ul class="subsrcibe">
                <li v-for="(item, i) in memberList" :key="i" @click="change(item, i)" :class="i == pro_id ? 'showIcon' : ''">
                  <div class="subsrcibe-box">
                    <div class="img" v-if="i == pro_id">
                      <img src="@/assets/img/icon_select.png" alt />
                    </div>
                    <div class="limited" v-if="
                      item.original_price != null &&
                      item.original_price > item.price
                    ">
                      限时优惠
                    </div>
                    <p>{{ item.description }}</p>
                    <div class="message">
                      ￥
                      <span>{{ item.price }}</span>
                      /{{ date_type[item.order_type] }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="pay-method">
              <div class="method">
                <el-button :class="isSelect == 0 ? 'selectBtn' : ''" @click="payMethod(0)">
                  <div class="icon">
                    <img src="@/assets/img/icon_wechart.png" alt />
                    <span>微信支付</span>
                  </div>
                </el-button>
                <el-button :class="isSelect == 0 ? '' : 'isActive'" @click="payMethod(1)">
                  <div class="icon">
                    <img src="@/assets/img/icon_alipay.png" alt />
                    <span>支付宝支付</span>
                  </div>
                </el-button>
              </div>
              <div class="pay-message">
                <div class="wechart">
                  <div class="img" v-show="!showRet && isSelect == 1" style="height: 153px;">
                    <iframe :src="wechat" style="width: 140px;margin-top: 10px;margin-left: 4px;border:none"></iframe>
                  </div>
                  <div class="img" v-show="!showRet && isSelect == 0">
                    <canvas id="canvas"></canvas>
                  </div>
                  <div v-if="showBtn">
                    <p @click="getWechat" v-if="showRet" style="cursor: pointer;margin-right:40px">
                      {{ tip }}
                    </p>
                  </div>
                  <p v-else style="cursor: pointer;margin-right:40px">
                    {{ code_ts }}
                  </p>
                </div>
                <div class="pay">
                  <p>
                    {{ price_type[isSelect] }}扫码，支付 <span>{{ price }}</span>元
                  </p>
                  <p>支付账号：{{ info.login_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog :visible.sync="paperDialog" width="420px" :close-on-click-modal="false">
      <div class="agreeList editName">
        <h3>纸刊激活</h3>
        <el-form :model="myForm" :rules="rules" ref="myForm" class="demo-ruleForm">
          <el-form-item prop="activationName" label="姓名">
            <el-input placeholder="请输入姓名" v-model="myForm.activationName"></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="手机号码">
            <el-input placeholder="请输入手机号码" v-model="myForm.phone"></el-input>
          </el-form-item>
          <el-form-item prop="city" label="地址">
            <el-cascader v-model="areaId" ref="myCascader" placeholder="请选择地址" :props="cityProps" :options="cityOptions" @change="handleChange"></el-cascader>
          </el-form-item>
          <el-form-item prop="address" label="详细地址">
            <el-input placeholder="请输入详细地址" v-model="myForm.address"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="邮箱">
            <el-input placeholder="请输入邮箱" v-model="myForm.email"></el-input>
          </el-form-item>
          <el-form-item prop="activationCode" label="激活码">
            <el-input placeholder="请输入激活码" v-model="myForm.activationCode"></el-input>
          </el-form-item>
          <el-form-item prop="startAt" label="开始投递时间">
            <el-date-picker v-model="myForm.startAt" type="date" placeholder="请选择开始投递时间" :picker-options="pickerOptions" :size="size" />
          </el-form-item>
        </el-form>
        <el-button @click="paperSubmit">提交</el-button>
      </div>
    </el-dialog>
    <LoginDialog :loginDialogs="loginDialogs" @child-event="getParentEvent" @token="getToken"></LoginDialog>
  </div>
</template>
<script>
import {
  getMemberList,
  getMemberOrder,
  getNotify,
  getProvinces,
  getCities,
  getDistricts,
  getActivityMagazine,
  getMagazine,
} from "@/api/member";
import { getUserInfo } from "@/api/public";
import Wechart from "@/components/wechart";
import LoginDialog from "@/components/loginDialog";
import QRCode from "qrcode";
import { getTdkList } from "@/api/tdk";
export default {
  components: {
    Wechart,
    LoginDialog,
  },
  data() {
    return {
      paperDialog: false,
      cityProps: {
        lazy: true,
        lazyLoad: this.lazyLoadRegion,
        leaf: "isLeaf",
      },
      cityOptions: [],
      pickerOptions: {
        disabledDate: (time) => {
          const today = new Date();
          today.setMonth(today.getMonth() + 1); // 加一个月
          return time.getTime() < today.getTime();
        },
      },
      areaId: [],
      myForm: {
        userId: 0,
        activationName: "",
        phone: "",
        city: "", // 用于存储省份/城市/区县的选择结果
        address: "",
        email: "",
        activationCode: "",
        startAt: "",
      },
      rules: {
        activationName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        city: [{ required: true, message: "请选择地址", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
        activationCode: [
          { required: true, message: "请输入激活码", trigger: "blur" },
        ],
        startAt: [
          { required: true, message: "请选择起投月份", trigger: "change" },
        ],
      },
      loginDialogs: false,
      tip: "刷新二维码",
      showRet: true,
      wechat: "",
      price_type: ["微信", "支付宝"],
      price: 0,
      memberImg: require("@/assets/img/member.png"),
      detailImg: require("@/assets/img/member_detail.png"),
      subscribeDialog: false,
      isSelect: 0, //默认微信支付 true
      // 会员订阅，会员套餐
      memberList: [],
      date_type: {
        month: "月",
        pro_year: "年",
        lite_year: "年",
      },
      pro_id: 0,
      info: {
        img: require("@/assets/img/code.png"),
        name: "李晓雅",
        phone: "187****2726",
        buyMoney: "18",
        wechart: require("@/assets/img/code.png"),
      },
      intervalId: null,
      numRefresh: 0,
      // 倒计时
      showBtn: true,
      code_ts: "请5秒后重试",
      sec: 10,
    };
  },
  created() {
    getProvinces().then((res) => {
      console.log(res);
      this.cityOptions = res.data.data.map((province) => ({
        value: province.base_areaid,
        label: province.name,
        isLeaf: false, // 省份不是叶子节点，还有城市
      }));
    });
    getTdkList({ column: 0 }).then((res) => {
      console.log(res);
      const head = document.getElementsByTagName("head");
      const meta = document.createElement("meta");
      document.title = res.data.data[0].title;
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute("content", res.data.data[0].keyword);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", res.data.data[0].describe);
      head[0].appendChild(meta);
    });
    this.$ba([
      ["ptype", "list"],
      ["acategory", "subscribe"],
      ["acname", "订阅"],
    ]);

    if (localStorage.getItem("Authorization") != null) {
      this.setUserInfo();
    }
    this.getMember();
    // this.getActivationCode()
  },
  methods: {
    paperSubmit() {
      this.$refs.myForm.validate(async (valid) => {
        if (valid) {
          const res = await getMagazine(this.myForm);
          if (res.data.code != 0) {
            this.$message.error(res.data.msg);
          }
          const data = res.data.data;
          if (data.status == "兑换成功") {
            this.$message.success(data.status);
            setTimeout(() => {
              location.reload();
            }, 1000);
          } else {
            this.$message.error("兑换失败");
          }
        }
      });
    },
    async getActivationCode() {
      this.paperDialog = true;
      var userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.myForm.userId = userInfo.id;
      const res = await getActivityMagazine({
        userId: this.myForm.userId,
      });
      this.myForm.activationCode = res.data.data.activationCode;
    },
    async lazyLoadRegion(node, resolve) {
      const { level, data } = node;
      try {
        let children = [];
        if (level === 1) {
          // 加载城市
          const response = await getCities(data.value);
          children = response.data.data.map((city) => ({
            value: city.base_areaid,
            label: city.name,
            isLeaf: false, // 城市不是叶子节点，还有区县
          }));
        } else if (level === 2) {
          // 加载区县
          const response = await getDistricts(data.value);
          children = response.data.data.map((district) => ({
            value: district.base_areaid,
            label: district.name,
            isLeaf: true, // 区县是叶子节点
          }));
        }
        resolve(children);
      } catch (error) {
        console.error("加载地区数据失败:", error);
        this.$message.error("加载地区数据失败");
        resolve([]);
      }
    },
    handleChange() {
      this.myForm.city = this.$refs.myCascader.getCheckedNodes()[0].pathLabels.join("-");
    },
    // 弹框
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    getToken(data) {
      this.token = data;
    },
    clearInt() {
      if (this.intervalId != null) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    setWechat(src = "") {
      if (src != "") {
        if (this.isSelect == 0) {
          var canvas = document.querySelector("canvas");
          QRCode.toCanvas(canvas, src);
        } else {
          this.wechat = src;
        }
        this.showRet = false;
      } else {
        this.tip = "刷新二维码";
        this.showRet = true;
      }
    },
    // 刷新二维码
    getWechat() {
      if (this.numRefresh > 0) {
        var timer = setInterval(() => {
          this.sec = this.sec - 1;
          this.code_ts = this.sec + "s后重试";
          this.showBtn = false;
          if (this.sec === 0) {
            clearInterval(timer);
            this.sec = 10;
            this.code_ts = this.sec + "s后重试";
            this.showBtn = true;
            this.showRet = true;
          }
        }, 1000);

        this.numRefresh = 0;
      } else {
        if (this.isSelect == 0) {
          var channel = "wx_wap";
        } else {
          var channel = "alipay_wap";
        }
        var params = {
          channel: channel,
          uid: this.info.yicai_user_id,
          yicai_platform: "pc",
          putType: "1",
          quantity: 1,
          product_id: this.memberList[this.pro_id].name,
          title: this.memberList[this.pro_id].description,
        };

        getMemberOrder(params).then((res) => {
          if (res.data.hasOwnProperty("error")) {
            this.tip = "已购买";
          } else if (res.data.data.ret == 200) {
            this.setWechat(res.data.data.data.code_url);
            this.notify = res.data.data.data;
            this.getNotify(res.data.data.order_no);
          }
        });
        this.numRefresh++;
      }
    },
    getNotify(id) {
      var _this = this;
      this.intervalId = setInterval(function () {
        getNotify(id).then((res) => {
          // if (res.data.data.status == "paid") {
          console.log(res);
          if (res.data.data.status === 0) {
            _this.$message.success("支付成功");
            setTimeout(function () {
              _this.clearInt();
              if (_this.pro_id == 0) {
                _this.getActivationCode();
              } else {
                location.reload();
              }
            }, 1000);
          }
        });
      }, 5000);
    },
    getMember() {
      var params = {
        type: "android",
      };
      getMemberList(params).then((res) => {
        this.memberList = res.data.data;
        this.price = this.memberList[0].price;
      });
    },
    setUserInfo() {
      getUserInfo().then((res) => {
        this.info = res.data.data;
        this.resetSetItem("userInfo", JSON.stringify(res.data.data));
      });
    },
    // 切换会员套餐
    change(scope, flag) {
      this.pro_id = flag;
      this.price = scope.price;
      this.setWechat();
    },
    // 切换支付方式
    payMethod(tag) {
      this.isSelect = tag;
      this.setWechat();
    },
    // 关闭弹框
    subscribeClose() {
      this.subscribeDialog = false;
      this.pro_id = 0;
      this.isSelect = true;
    },
    // 开通会员
    memberBtn() {
      if (
        localStorage.getItem("Authorization") != "" &&
        localStorage.getItem("Authorization") != null
      ) {
        this.subscribeDialog = true;
      } else {
        this.loginDialogs = true;
      }
    },
  },
  destroyed() {
    this.clearInt();
  },
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;

  .crumb {
    cursor: pointer;
  }

  span:last-child {
    color: #0091ff;
  }
}

.member {
  background: #ffffff;
  padding: 30px;
  text-align: center;
  margin-bottom: 30px;

  h3 {
    font-size: 30px;
    font-weight: 300;
    color: #e1b24a;
    text-align: center;
    margin-bottom: 15px;
  }

  img {
    width: 100%;
    object-fit: cover;
  }

  .el-button {
    width: 33%;
    height: 46px;
    border-radius: 23px;
    color: #ffffff;
    border: 1px solid;
    background: #e1b24a;
    margin-top: 20px;
  }
}

.singleDialog {
  >>> .el-dialog__header {
    display: none;
  }

  >>> .el-dialog__body {
    padding: 0;
    margin-top: 5px;
  }

  .singleList {
    .header {
      display: flex;
      justify-content: space-between;
      background: url("../../assets/img/bg_single.png") no-repeat;
      padding: 20px 20px 20px 30px;
      background-size: auto;

      .message {
        display: flex;

        .img {
          width: 70px;
          height: 70px;
          margin-right: 20px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }

        div {
          p {
            font-size: 20px;
            color: #9a6416;
            margin-top: 6px;
          }

          p:last-child {
            font-size: 14px;

            span {
              color: #ff0000;
            }
          }
        }
      }
    }

    .dialog-body {
      padding: 6px 30px 30px 30px;

      h3 {
        color: #dfb349;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 40px;

        span {
          vertical-align: middle;
          display: inline-block;
        }

        img {
          vertical-align: middle;
          display: inline-block;
        }
      }

      .body-message {
        display: flex;

        .subsrcibe {
          display: flex;
          width: 100%;
          justify-content: space-between;

          li {
            width: 30.5%;
            border: 1px solid #eeeeee;
            position: relative;
            cursor: pointer;

            .subsrcibe-box {
              width: 100%;
              text-align: center;
              padding: 10px;
              font-size: 16px;

              .img {
                img {
                  position: absolute;
                  left: 10px;
                  top: 10px;
                }
              }

              .limited {
                position: absolute;
                background: #ff0000;
                padding: 5px 12px;
                border-radius: 0 10px 0 10px;
                right: -2px;
                top: -17px;
                color: #fff;
                font-size: 14px;
              }

              p {
                line-height: 36px;
                margin-top: 20px;
              }

              .message {
                color: #dfb349;
                font-size: 18px;
                margin-bottom: 10px;

                span {
                  font-size: 30px;
                  font-weight: 600;
                  margin-left: -9px;
                }
              }
            }
          }

          .showIcon {
            border: 2px solid #dfb349;
            background: #fcf7e6;
          }
        }
      }

      .pay-method {
        border: 1px solid #eeeeee;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;

        .method {
          display: flex;
          flex-direction: column;
          margin-right: 40px;

          .el-button {
            border: 1px solid #eeeeee;
            background: #f5f5f5;
            text-align: center;
            line-height: 100px;
            border: none;
            margin-left: 0;
            border-radius: 0;
            font-size: 16px;
            padding: 0 40px;

            .icon {
              img {
                vertical-align: middle;
                margin-right: 4px;
              }
            }
          }

          .selectBtn {
            background: #fff;
            border-right: 0;
          }

          .isActive {
            background: #fff;
            border-right: 0;
          }

          >>> .el-button:hover,
          .el-button:active,
          .el-button:focus {
            color: #333 !important;
          }
        }

        .pay-message {
          display: flex;
          align-items: center;
          margin-right: 16px;

          .wechart {
            text-align: center;
            color: #999999;
            margin-right: 30px;

            .img {
              // max-width: 130px;
              padding: 10px;
              border: 1px solid #eeeeee;
              margin-bottom: 6px;

              img {
                width: 100%;
                object-fit: cover;
              }

              >>> #canvas {
                width: 136px;
                height: 136px;
              }
            }
          }

          .pay {
            font-size: 16px;

            p {
              line-height: 38px;

              span {
                color: #dfb349;
                font-size: 30px;
                font-weight: bold;
              }
            }

            p:last-child {
              color: #999999;
            }
          }
        }
      }
    }
  }
}

.agreeDialog {
  >>> .el-dialog__body {
    padding: 0px 5%;
    margin-top: 5px;
  }
}

.agreeList {
  color: #333333;

  h3 {
    font-size: 30px;
    line-height: 36px;
  }

  ul {
    text-align: left;
    margin-top: 20px;
    padding-bottom: 40px;

    li {
      line-height: 22px;
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;
    }
  }
}

.editName {
  padding: 0 30px;

  .el-button {
    width: 100%;
    border-radius: 23px;
    background: #0099f1;
    color: #fff;
    padding: 14px 20px;
    margin-bottom: 30px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/member/index.vue